import axios from 'axios'

// Determinar URL base da API
// Em desenvolvimento (sem VITE_API_URL), usar o proxy do Vite (/api)
// Em produção ou com VITE_API_URL definido, usar a URL configurada
const getApiBaseUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL
  
  // Se não tem URL configurada, usar proxy do Vite
  if (!envUrl) {
    return '/api'
  }
  
  // Se a URL não termina com /api, adicionar
  if (!envUrl.endsWith('/api')) {
    return `${envUrl.replace(/\/$/, '')}/api`
  }
  
  return envUrl
}

const API_BASE_URL = getApiBaseUrl()

console.log('[API] Base URL:', API_BASE_URL)

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Permitir envio de cookies em requisições cross-origin
  withCredentials: true,
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('wedrop_support_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('wedrop_support_token')
      localStorage.removeItem('wedrop_support_user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
